import { useEffect, useState } from "react"
import { usePathData, useAdminBar } from "@/lib/contexts/appContext"

import Main from "@/components/wrappers/main"
import Blocks from "@/components/Blocks"
import cx from "classnames"

export function Archive() {
  const pathData = usePathData()
  const adminBar = useAdminBar()
  const [classes, setClasses] = useState([
    "template-" + pathData.template,
    "text-black-100"
  ])

  useEffect(() => {
    setClasses([...classes, adminBar ? "pt-12 sm:pt-12 md:pt-9" : null])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathData])

  return (
    <Main className={cx(classes)}>
      <Blocks blocks={pathData.content} />
    </Main>
  )
}

export default Archive
